/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import Operation from './components/Operation';
import EmotionAnalysis from './components/EmotionAnalysis';
import CameraArea from '../MainArea/Room/CameraArea';
import { isMobile } from '@/utils/utils';
import { useScene } from '@/lib/useCommon';
import styles from './index.module.less';

/**
 * Menu 组件
 * 
 * 显示条件：PC 端 + 进入对话页面
 * 包含：麦克风操作模块、情绪分析模块
 * 
 * SSE 连接由 MainPage 层级的 EmotionWarnings 组件管理
 * EmotionAnalysis 通过全局事件接收 SSE 数据
 */
function Menu() {
  const room = useSelector((state: RootState) => state.room);
  const auth = useSelector((state: RootState) => state.auth);
  const isJoined = room?.isJoined;
  const { isVision } = useScene();

  return (
    <div className={styles.wrapper}>
      {isJoined && isMobile() && isVision ? (
        <div className={styles['mobile-camera-wrapper']}>
          <CameraArea className={styles['mobile-camera']} />
        </div>
      ) : null}
      
      {/* 麦克风模块 - 始终显示 */}
      <Operation />
      
      {/* 情绪分析模块 - 只在用户登录且加入房间后显示 */}
      {auth.isAuthenticated && isJoined ? (
        <div className={`${styles.box} ${styles.info} ${styles.scrollable}`}>
          <EmotionAnalysis />
        </div>
      ) : null}
    </div>
  );
}

export default Menu;
